import React from 'react';
import ReactDOM from "react-dom";
import MaterialTable, { MTableToolbar } from 'material-table';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import GetAppIcon from '@material-ui/icons/GetApp';

export default class CampaignPageParticipant extends React.Component {
  constructor(props) {
    super(props);
    // console.log(this.props.tags);
    this.tableRef = React.createRef();
    this.theme = createMuiTheme({
      palette: {
        primary: {
          main: '#7cb342',
        },
        secondary: {
          main: '#4caf50',
        },
      },
    });
    this.state = {
      columns: [
        // { title: 'ID', field: 'id', editable: 'never' },
        { title: 'Name', field: 'name', grouping: false },
        { title: 'Phone number', field: 'phone_number',grouping: false },
        { title: 'Date of Birth', field: 'dob', grouping: false },
        { title: 'Date of Birth', field: 'dob', grouping: false },
        {
          title: 'File',
          field: 'file_url',
          render: rowData => <a href={rowData.file_url} className="text-success" target="_blank"><GetAppIcon fontSize="large"/></a>
        },
        { title: 'Created at', field: 'created_at', grouping: false },
        // { title: 'Created at', field: 'created_at', editable: 'never', width: 250 },
      ],
      data: [],
      page: null,
      open: false,
      totalCount: null
    }
  }

  fetchData(query){
    return new Promise((resolve, reject) => {
      let url = `/api/campaign_pages/${this.props.campaign_page_id}/participants.json?`
      // console.log('params', query)
      url += 'per_page=' + query.pageSize
      url += '&q=' + query.search
      url += '&page=' + (query.page + 1)
      fetch(url)
        .then(res => (res && res.status === 200 && res.ok ? res.json() : Promise.reject(res)))
        .then(data => {
          resolve({
            data: data.participants,
            page: data.pagination.page - 1,
            totalCount: data.pagination.count
          })
        })
    })
  }

  render() {
    return (
      <MuiThemeProvider theme={this.theme}>
        <MaterialTable
          title={this.props.title}
          columns={this.state.columns}
          tableRef={this.tableRef}
          actions={[
            {
              icon: 'refresh',
              tooltip: 'Refresh Data',
              isFreeAction: true,
              onClick: () => this.tableRef.current && this.tableRef.current.onQueryChange(),
            },
            // {
            //   tooltip: 'Remove All Selected Users',
            //   icon: 'delete',
            //   onClick: (evt, data) => this.batchDelete(data) && this.setState({open: true})
            // }
          ]}
          options={{
            pageSize: 50,
            pageSizeOptions: [50, 100, 200, 500, 1000],
            exportButton: true,
            sorting: true,
            search: true,
            addRowPosition: 'first',
            grouping: true
            // filtering: true
          }}
          data={query =>
            this.fetchData(query)
          }
        />
      </MuiThemeProvider>
    )
  }
}
